import { render, staticRenderFns } from "./ProjectAttachment.vue?vue&type=template&id=6afb38f2&scoped=true"
import script from "./ProjectAttachment.vue?vue&type=script&lang=js"
export * from "./ProjectAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb38f2",
  null
  
)

export default component.exports